import { render } from "./rateCard.vue?vue&type=template&id=287a31f6&scoped=true&ts=true"
import script from "./rateCard.vue?vue&type=script&lang=ts"
export * from "./rateCard.vue?vue&type=script&lang=ts"

import "./rateCard.vue?vue&type=style&index=0&id=287a31f6&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287a31f6"]])

export default __exports__